var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-item"},[_vm._m(0),_c('dv-scroll-board',{staticClass:"panel-item_datav",attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_name",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',[_vm._v("今日分销者红榜")])])
}]

export { render, staticRenderFns }